/**
 * HTML escaping utility
 *
 * Prevents XSS in any server- or client-side HTML string concatenation.
 * Use this on every user-controlled value interpolated into an HTML template.
 */

/**
 * Escape special HTML characters in a string so that it renders as
 * literal text rather than being interpreted as markup or script.
 *
 * Handles: & < > " '
 * Treats null / undefined as an empty string.
 */
export function escapeHtml(str: string | null | undefined): string {
  if (str == null) return '';
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
